import { render, staticRenderFns } from "./SfBottomNavigation.vue?vue&type=template&id=5b744ae0"
import script from "./SfBottomNavigation.vue?vue&type=script&lang=js"
export * from "./SfBottomNavigation.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfBottomNavigation.vue?vue&type=style&index=0&id=5b744ae0&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "1a740f26"
  
)

export default component.exports